import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyDz9BpEaxhHPB59_x6NeG7uI2XEHx8Tr4E',
  authDomain: 'fixxinvest-c21c3.firebaseapp.com',
  projectId: 'fixxinvest-c21c3',
  storageBucket: 'fixxinvest-c21c3.appspot.com',
  messagingSenderId: '524335387900',
  appId: '1:524335387900:web:41a27a78030fd9cba6f379',
}

const app = initializeApp(firebaseConfig)

export const auth = getAuth(app)
export const db = getFirestore(app)